import React from "react";
import { Button, Dialog, Flex } from "@radix-ui/themes";

const BaseModalWindow: React.FunctionComponent<{
  show: boolean;
  closeModal: () => void;
  size?: string | undefined;
  title?: string;
  styles?: string;
  children: React.ReactNode;
}> = (props) => {
  if (!props.show) return null;

  return (
    <Dialog.Content size="2" minWidth={"40vw"}>
      <Dialog.Title>{props.title}</Dialog.Title>

      <Flex>{props.children}</Flex>
    </Dialog.Content>
  );
};

export default BaseModalWindow;
